import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import { compose } from "redux";

import logo from "assets/images/sbs/Logo-Say-What.png";
import SmallBitesUsers from "../../smallBites/smallBitesUsers";

const CcStart = ({ onStartGame }) => {
  return (
    <>
      <img src={logo} alt="logo" />
      <p className="info my-3">Click Start Game once everyone has joined!</p>
      <div className="players-box-wrap">
        <SmallBitesUsers />
      </div>
      <Button onClick={onStartGame} className="start-game">
        start game
      </Button>
    </>
  );
};
const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

export default compose(withRouter, connect(mapStateToProps))(CcStart);
